/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddEmergencyConfigRequest,
  DeleteEmergencyConfigRequest,
  EmergencyConfigurationOnAzure,
  UpdateEmergencyConfigRequest,
} from '../models/index';
import {
    AddEmergencyConfigRequestFromJSON,
    AddEmergencyConfigRequestToJSON,
    DeleteEmergencyConfigRequestFromJSON,
    DeleteEmergencyConfigRequestToJSON,
    EmergencyConfigurationOnAzureFromJSON,
    EmergencyConfigurationOnAzureToJSON,
    UpdateEmergencyConfigRequestFromJSON,
    UpdateEmergencyConfigRequestToJSON,
} from '../models/index';

export interface ApiEmergencyConfigAddEmergencyConfigPostRequest {
    addEmergencyConfigRequest?: AddEmergencyConfigRequest;
}

export interface ApiEmergencyConfigDeleteEmergencyConfigDeleteRequest {
    deleteEmergencyConfigRequest?: DeleteEmergencyConfigRequest;
}

export interface ApiEmergencyConfigGetAllByOrgCodeGetRequest {
    orgCode?: string;
}

export interface ApiEmergencyConfigGetByOrgCodeAndIdGetRequest {
    orgCode?: string;
    configId?: string;
}

export interface ApiEmergencyConfigUpdateEmergencyConfigPutRequest {
    updateEmergencyConfigRequest?: UpdateEmergencyConfigRequest;
}

/**
 * 
 */
export class EmergencyConfigApi extends runtime.BaseAPI {

    /**
     */
    async apiEmergencyConfigAddEmergencyConfigPostRaw(requestParameters: ApiEmergencyConfigAddEmergencyConfigPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergencyConfigurationOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/EmergencyConfig/AddEmergencyConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddEmergencyConfigRequestToJSON(requestParameters['addEmergencyConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergencyConfigurationOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiEmergencyConfigAddEmergencyConfigPost(requestParameters: ApiEmergencyConfigAddEmergencyConfigPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergencyConfigurationOnAzure> {
        const response = await this.apiEmergencyConfigAddEmergencyConfigPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEmergencyConfigDeleteEmergencyConfigDeleteRaw(requestParameters: ApiEmergencyConfigDeleteEmergencyConfigDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/EmergencyConfig/DeleteEmergencyConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteEmergencyConfigRequestToJSON(requestParameters['deleteEmergencyConfigRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiEmergencyConfigDeleteEmergencyConfigDelete(requestParameters: ApiEmergencyConfigDeleteEmergencyConfigDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiEmergencyConfigDeleteEmergencyConfigDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiEmergencyConfigGetAllByOrgCodeGetRaw(requestParameters: ApiEmergencyConfigGetAllByOrgCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EmergencyConfigurationOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/EmergencyConfig/GetAllByOrgCode`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmergencyConfigurationOnAzureFromJSON));
    }

    /**
     */
    async apiEmergencyConfigGetAllByOrgCodeGet(requestParameters: ApiEmergencyConfigGetAllByOrgCodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EmergencyConfigurationOnAzure>> {
        const response = await this.apiEmergencyConfigGetAllByOrgCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEmergencyConfigGetByOrgCodeAndIdGetRaw(requestParameters: ApiEmergencyConfigGetByOrgCodeAndIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergencyConfigurationOnAzure>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        if (requestParameters['configId'] != null) {
            queryParameters['config_id'] = requestParameters['configId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/EmergencyConfig/GetByOrgCodeAndId`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergencyConfigurationOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiEmergencyConfigGetByOrgCodeAndIdGet(requestParameters: ApiEmergencyConfigGetByOrgCodeAndIdGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergencyConfigurationOnAzure> {
        const response = await this.apiEmergencyConfigGetByOrgCodeAndIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEmergencyConfigUpdateEmergencyConfigPutRaw(requestParameters: ApiEmergencyConfigUpdateEmergencyConfigPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergencyConfigurationOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/EmergencyConfig/UpdateEmergencyConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEmergencyConfigRequestToJSON(requestParameters['updateEmergencyConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergencyConfigurationOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiEmergencyConfigUpdateEmergencyConfigPut(requestParameters: ApiEmergencyConfigUpdateEmergencyConfigPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergencyConfigurationOnAzure> {
        const response = await this.apiEmergencyConfigUpdateEmergencyConfigPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
